import Util from "../../../locatorAlerts/Util.js";
import { LOCATOR_ALERTS } from "../../../constants/index.js";
const opts = {
  filterable: true,
  sortable: false
};
const constants = {
  ...LOCATOR_ALERTS,
  NOT_ACTIVATED: 'not-activated'
};
const alertLabels = () => ({
  [constants.THEFT_RECOVERY_ACTIVATED]: 'Theft Recovery Activated',
  [constants.THEFT_RECOVERY_ACTIVATING]: 'Theft Recovery Activating',
  [constants.THEFT_RECOVERY_ENDING]: 'Theft Recovery Ending',
  [constants.POSITION_PENDING]: 'Position Pending',
  [constants.PENDING_AUTOMATIC_LOCATION_TRANSFER]: 'Pending Automatic Location Transfer',
  [constants.DEVICE_HEALTH]: 'Device Health Problem',
  [constants.END_OF_LIFE]: 'End of Life',
  [constants.NOT_REPORTING]: 'Not Reporting',
  [constants.NON_OPERATIONAL]: 'Not Operational',
  [constants.NOT_ACTIVATED]: 'Not Activated'
});
const alertVariants = {
  [constants.THEFT_RECOVERY_ACTIVATED]: 'pillTheftActive',
  [constants.THEFT_RECOVERY_ACTIVATING]: 'pillTheftActive',
  [constants.THEFT_RECOVERY_ENDING]: 'pillTheftEnding',
  [constants.POSITION_PENDING]: 'pillPrimary',
  [constants.PENDING_AUTOMATIC_LOCATION_TRANSFER]: 'pill',
  [constants.DEVICE_HEALTH]: 'pillWarning',
  [constants.END_OF_LIFE]: 'pillWarning',
  [constants.NOT_REPORTING]: 'pillWarning',
  [constants.NON_OPERATIONAL]: 'pillWarning',
  [constants.NOT_ACTIVATED]: 'pillWarning'
};
export default {
  id: 'assetLocators.calculatedAlerts',
  name: 'assetLocators.calculatedAlerts',
  displayName: 'Alerts',
  valueType: 'string',
  objectType: 'assetLocators',
  blueprint: {},
  getOption: key => {
    return opts[key];
  },
  get: obj => {
    const toReturn = [];
    const hasLocator = obj?.data?.locator?.id != null;
    // const pendingReplaceSale = obj?.data?.saleState === VEHICLE_SALE_STATES.PENDING_REPLACE_LOCATOR

    if (hasLocator) {
      const locatorAlerts = obj.data.locator.data?.locatorAlerts || {};
      Object.values(constants).forEach(val => {
        if (locatorAlerts[val]) {
          toReturn.push(val);
        }
      });
      const unActivated = !obj?.data?.locator?.data?.lastHeartbeat;
      if (unActivated) {
        toReturn.push(constants.NOT_ACTIVATED);
      } else {
        // Only check reporting status for activated locators
        if (Util.isLocatorNotReporting(obj?.data?.locator)) {
          toReturn.push(constants.NOT_REPORTING);
        }
        if (Util.isLocatorNonOperational(obj?.data?.locator)) {
          toReturn.push(constants.NON_OPERATIONAL);
        }
      }
      if (!Util.isLocatorNonOperational(obj?.data?.locator) && toReturn.includes(constants.NON_OPERATIONAL)) {
        const index = toReturn.indexOf(constants.NON_OPERATIONAL);
        toReturn.splice(index, 1);
      }
    }
    return toReturn;
  }
};
export { alertLabels, alertVariants, constants };